import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseConfigService } from '@synx-cloud/services';
import { EnvironmentEnum } from 'node_modules/@synx-cloud/types';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService extends BaseConfigService {
  logoutPath: string = '/DeviceManagementUsers/logout';
  appPathPrefix: string = '';
  environmentPathMap: Partial<Record<EnvironmentEnum, string>> = {
    [EnvironmentEnum.dev]: './assets/config/environment.json',
    [EnvironmentEnum.production]: './assets/config/environment.json'
  };
  environment: { production: boolean; environment: EnvironmentEnum; } = environment;

  constructor(http: HttpClient) {
    super(http);
  }
}
